import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

var twitterText = require('twitter-text');

import { Icon } from 'components';
import { retweetTweet, quoteRetweetTweet, updateReplyText, uploadMedia, removeMedia } from 'redux/modules/messageCenter';
import * as styles from './TwitterRetweetField.scss';
var TwitterRetweetField = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  retweetTweet: retweetTweet,
  quoteRetweetTweet: quoteRetweetTweet,
  updateReplyText: updateReplyText,
  uploadMedia: uploadMedia,
  removeMedia: removeMedia
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TwitterRetweetField, _Component);

  var _super = _createSuper(TwitterRetweetField);

  function TwitterRetweetField(props) {
    var _this;

    _classCallCheck(this, TwitterRetweetField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getSocialAccount", function () {
      var _this$props = _this.props,
          organization = _this$props.organization,
          parent = _this$props.parent;
      var sa = false;

      if (parent.parentObjectId) {
        // if we have a parentObjectId, this will work
        organization.SocialAccounts.forEach(function (a) {
          if (a.platformId === parent.parentObjectId) {
            sa = a;
          }
        });
      } else {
        // otherwise, look through and find the FB page
        for (var i = 0; i < _this.props.organization.SocialAccounts.length; i++) {
          var a = _this.props.organization.SocialAccounts[i];

          if (a.platform === 'Facebook page') {
            sa = a;
          }
        }
      }

      return sa;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCharCount", function (e) {
      var count = 140 - twitterText.getTweetLength(e.target.value);

      _this.setState({
        charCount: count
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.setState({
        reply: e.target.value
      });

      _this.handleCharCount(e);

      if (_this.props.item && (_this.props.item.ConversationId || _this.props.item.parentMessageId)) {
        _this.props.updateReplyText(e.target.value, _this.props.conversationId, _this.props.item.id);
      } else if (_this.props.parent) {
        _this.props.updateReplyText(e.target.value, _this.props.conversationId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (files) {
      if (_this.props.item && (_this.props.item.ConversationId || _this.props.item.parentMessageId)) {
        _this.props.uploadMedia(files, _this.props.conversationId, _this.props.item.id);
      } else if (_this.props.parent) {
        _this.props.uploadMedia(files, _this.props.conversationId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var orgId = _this.props.organization.id;

      var socialAccountId = _this.props.organization.SocialAccounts.filter(function (a) {
        return a.platform === 'Twitter';
      })[0].id;

      var tweetId = _this.props.tweetId;
      var text = _this.state.reply;

      if (_this.state.charCount < 140) {
        // quote retweet
        _this.props.quoteRetweetTweet(orgId, socialAccountId, tweetId, text);
      } else {
        // retweet
        _this.props.retweetTweet(orgId, socialAccountId, tweetId);
      }

      _this.props.closeField();
    });

    _this.state = {
      charCount: 140,
      reply: ''
    };
    return _this;
  }

  _createClass(TwitterRetweetField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var dropzoneRef;
      var _this$props2 = this.props,
          item = _this$props2.item,
          parent = _this$props2.parent;
      var replyText = (item ? item.replyText : this.props.parent.replyText) || '';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: styles.retweetHeader
      }, this.state.charCount < 140 ? 'Quote Tweet' : 'Retweet this to your followers?', /*#__PURE__*/React.createElement("span", {
        className: styles.closeBtn,
        onClick: function onClick() {
          return _this2.props.closeField();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-close-empty ".concat(styles.closeIcon)
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, /*#__PURE__*/React.createElement(Dropzone, {
        className: styles.dropzone,
        disableClick: true,
        disablePreview: true,
        multiple: false,
        onDrop: this.handleDrop,
        ref: function ref(node) {
          dropzoneRef = node;
        },
        style: {
          flex: '1 1 auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap,
        style: this.state.charCount < 140 ? {
          borderRadius: 26,
          flex: '1 1 auto'
        } : {
          flex: '1 1 auto'
        }
      }, /*#__PURE__*/React.createElement("textarea", {
        className: styles.textField,
        onChange: this.handleChange,
        value: this.state.reply,
        placeholder: "Add a comment...",
        style: this.state.charCount < 140 ? {
          height: 52
        } : {
          height: 18
        }
      })))), this.props.tweetBody, /*#__PURE__*/React.createElement("div", {
        className: styles.bottomRow
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, this.state.charCount < 140 && /*#__PURE__*/React.createElement("span", {
        className: styles.charCount,
        style: this.state.charCount < 0 ? {
          color: '#d40d12'
        } : {}
      }, this.state.charCount), /*#__PURE__*/React.createElement("span", {
        className: styles.btn,
        onClick: this.handleSubmit
      }, this.state.charCount < 140 ? 'Tweet' : 'Retweet'))));
    }
  }]);

  return TwitterRetweetField;
}(Component), _defineProperty(_class2, "propTypes", {
  item: PropTypes.any,
  parent: PropTypes.any,
  retweetTweet: PropTypes.func.isRequired,
  quoteRetweetTweet: PropTypes.func.isRequired
}), _temp)) || _class);
export default TwitterRetweetField;